import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BaseValidationResult } from "@ha/ui/forms";
import { Observable } from "rxjs";

import { ReplacementCardRequest } from "../models/replacement-card-request";
import { ReplacementCardRequestConfiguration } from "../models/replacement-card-request-configuration";

@Injectable({ providedIn: "root" })
export class ReplacementCardRequestService {
    constructor(private httpClient: HttpClient) {}

    public getConfiguration(): Observable<ReplacementCardRequestConfiguration> {
        return this.httpClient.get<ReplacementCardRequestConfiguration>("/api/ReplacementCardRequest/GetConfiguration");
    }

    public create(user: ReplacementCardRequest): Observable<BaseValidationResult> {
        return this.httpClient.post<BaseValidationResult>("/api/ReplacementCardRequest/Create", user);
    }
}
